import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, CircularProgress, Grid } from '@mui/material';
import { AccountLink, SubTitle, Title } from '../common';
import KenInput from '../../../Components/KenInput';
import KenButton from '../../../Components/KenButton';
import { useLocation, useNavigate } from 'react-router-dom';
import routes from '../../../Constants/routes';
import LoginBG from '../../../Assets/Svg/login-bg.svg';
import logo from '../../../Assets/Images/FLAME_University_Logo.png';
import MobileLoginBG from '../../../Assets/Svg/login-mobile-bg.svg';
import { useForm, Controller } from 'react-hook-form';
import validator from 'validator';
import { requestForOTP } from '../api';
import { useSnackbar } from 'notistack';
import KenLoader from '../../../Components/KenLoader';
import Carousel from 'nuka-carousel';
import { TABLET_BREAKPOINT } from '../../../Constants/constant';

const useStyles = makeStyles((theme) => ({
  carousel: {
    borderRadius: '0px 16px 16px 0px',
    height: '100% !important',
    'box-shadow': '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    '& .slider-list': {
      height: '100%',
    },
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      borderRadius: 0,
      boxShadow: 'unset',
    },
  },
  gridContainer: {
    height: '100%',
    width: '100%',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      height: '50%',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundImage: `url(${LoginBG})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${MobileLoginBG})`,
      marginTop: "30px"
    },
  },
  title: {
    marginBottom: '16px',
    color: '#041e39 !important',
  },
  subTitle: {
    marginBottom: '32px',
    color: '#041e39 !important',
  },
  inputFieldLabel: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '14px',
    'line-height': '100%',
    'text-transform': 'capitalize',
    color: '#505F79',
  },
  verify: {
    width: '100%',
    height: '48px',
    marginBottom: '40px',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: '#041e39 !important',
    fontFamily: 'Poppins,sans-serif',
  },
}));

const mobileOrEmail = (id) => {
  //Note strict mode will enable only validation with country code
  if (validator.isEmail(id) || validator.isMobilePhone(id, 'en-IN', { strictMode: true })) {
    return true;
  }

  return 'Please enter valid email.';
};

export default function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const query = new URLSearchParams(useLocation().search);
  const search = query.get('search');
  const programSearch = query.get('search_program');
  const imgData = [
    'https://inazstgpfs3001.blob.core.windows.net/assets/flame/flame-img/pic1.jpg',
    'https://inazstgpfs3001.blob.core.windows.net/assets/flame/flame-img/pic3.jpg',
    'https://inazstgpfs3001.blob.core.windows.net/assets/flame/flame-img/pic5.jpg',
    'https://inazstgpfs3001.blob.core.windows.net/assets/flame/flame-img/pic2.jpg',
    'https://inazstgpfs3001.blob.core.windows.net/assets/flame/flame-img/pic4.jpg',
  ];

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await requestForOTP(data);
      navigate(programSearch ? `${routes.loginOTP}?search_program=${programSearch}` : routes.loginOTP, {
        state: {
          id: res.applicantId,
          currentId: data.id,
          search: search ? search : '',
          programSearch: programSearch ? programSearch : '',
        },
      });
    } catch (error) {
      const customerror = error?.response?.data;
      if (!error?.response?.data || error?.response?.data?.success === false) {
        setTimeout(() => navigate(programSearch ? `${routes.signup}?search_program=${programSearch}` : routes.signup), 3000);
        return enqueueSnackbar(customerror?.errorMessage || 'Something went wrong', {
          variant: 'error',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const { control, handleSubmit } = useForm({
    defaultValues: {
      id: '',
    },
  });

  return (
    <Grid container direction="row" alignItems={'center'} className={classes.gridContainer}>
      <Grid item xs={12} md={6} height={"100%"}>
        <Carousel
          autoplay={imgData?.length <= 1 ? false : true}
          wrapAround={true}
          renderCenterRightControls={({ nextSlide }) => ''}
          renderCenterLeftControls={({ previousSlide }) => ''}
          withoutControls={imgData?.length <= 1 ? true : false}
          className={classes.carousel}
        >
          {imgData?.map((items, index) => {
            return <img src={items} key={index} style={{ height: '100%', width: '100%', objectFit: 'cover' }} alt="login" />;
          })}
        </Carousel>
      </Grid>
      <Grid item xs={12} md={6} height={"100%"}>
        <Box className={classes.container}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {false && <KenLoader />}
            <Box display={'flex'} flexDirection="column" justifyContent={'flex-center'} alignItems="flex-center">
              <img
                alt="logo"
                src={logo}
                style={{
                  height: '110px',
                  width: '110px',
                  justifyContent: 'flex-center',
                  marginLeft: '112px',
                  margin: '40px auto',
                }}
              />
              <Title className={classes.title} text="Login" />
              <SubTitle className={classes.subTitle} text="Please enter your login credentials below to start." />
              <Box mb={4} width="100%">
                <Controller
                  name="id"
                  control={control}
                  rules={{
                    required: 'Please enter Valid Email ID',
                    validate: { mobileOrEmail },
                    maxLength: {
                      value: 100,
                      message: 'This field cannot be more than 100 characters',
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <KenInput
                      // required
                      hideLabel={true}
                      name="id"
                      label="Email ID"
                      placeholder="Please enter your Email ID"
                      labelClassName={classes.inputFieldLabel}
                      error={error?.message || error?.type}
                      inputType="circular"
                      inputProps={classes.input}
                      {...field}
                    />
                  )}
                />
              </Box>
              <KenButton variant="roundedButton" buttonClass={classes.verify} type="submit" disabled={loading}>
                Verify
              </KenButton>
              {loading && <CircularProgress size={24} className={classes.circularProgress} />}
              <Box display={'flex'} justifyContent="space-between" width="100%" marginBottom="40px" marginLeft="40px">
                <AccountLink text="Don't have an account?" actionText={'Sign Up '} onAction={() => navigate(programSearch ? `${routes.signup}?search_program=${programSearch}` : routes.signup)} />
              </Box>
            </Box>
          </form>
          <img src={'https://inazstgpfs3001.blob.core.windows.net/assets/flame/flame-img/loginlogo.png'} alt="loginlogo" style={{ height: '60px', width: 'auto' }} />
        </Box>
      </Grid>
    </Grid>
  );
}
